import React from "react";
import DeviceInformationForm from "../DeviceInformationForm";

const PrimaryDeviceInformationForm = ({
  isLoading,
  handleCancelClick,
  handleSubmit,
}) => {
  return (
    <>
      <DeviceInformationForm
        isPrimaryDevice={true}
        handleCancelClick={handleCancelClick}
        handleSubmit={handleSubmit}
        isLoading={isLoading}
      />
    </>
  );
};

export default PrimaryDeviceInformationForm;
